module.exports = __webpack_public_path__ + "static/media/ai.a6b653e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ai.svg
// module id = 46
// module chunks = 0